import React from "react";
import { ArrowDown, ArrowUp } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Ya no es una tarjeta: un bloque sin borde ni fondo, separado de sus
 * vecinos por una línea vertical hairline. Reservado para KPIs de los
 * tableros: nunca un gráfico de una sola barra para representar un
 * número con su delta.
 */
export const StatCard = ({ label, value, delta, testId, warn, onClick }) => (
  <div
    data-testid={testId}
    onClick={onClick}
    className={cn(
      "flex-1 border-l border-line pl-5 first:border-l-0 first:pl-0",
      onClick && "cursor-pointer transition-opacity hover:opacity-70"
    )}
  >
    <p className="font-mono text-[11px] font-medium uppercase tracking-[0.08em] text-ink-tertiary">
      {label}
    </p>
    <p
      className={cn(
        "mt-2 font-mono text-[44px] font-medium leading-none tracking-[-0.03em]",
        warn ? "text-state-warn" : "text-ink"
      )}
    >
      {value ?? "—"}
    </p>
    {delta !== undefined && delta !== null && (
      <p
        className={cn(
          "mt-2 flex items-center gap-1 font-mono text-[12px] font-medium",
          delta >= 0 ? "text-state-ok" : "text-state-critical"
        )}
      >
        {delta >= 0 ? <ArrowUp className="h-3 w-3" /> : <ArrowDown className="h-3 w-3" />}
        {Math.abs(delta)}%
      </p>
    )}
  </div>
);
